<template>
  <div
    :class="$style.container"
    :style="!userTrail || `--themeColor: ${userTrail.color}`"
  >
    <TrailBodyBackground 
      v-if="userTrail" 
      :background="userTrail.background_style" />

    <LoadingContainer v-if="!userTrail" />

    <div
      v-else
      :class="$style.detailsContainer"
    >
      <div :class="$style.header">
        <div :class="$style.header__text">
          <router-link :to="{ name: 'trail.pick' }" :class="$style.changeButton">
            Mudar de trilha
          </router-link>

          <span :class="$style.header__text__subtitle">Você está na trilha</span>
          <h3 :class="$style.header__text__title">{{ userTrail.name }}</h3>
        </div>
      </div>

       <hr>

      <section :class="[$style.container__content, $style.mb__48]">
        <div :class="[$style.paragraph__2, $style.mb__48]" v-html="userTrail.description"></div>
      
        <div class="d-flex justify-content-center flex-column flex-md-row">
          <div class="px-0 px-md-4 py-2 py-md-0">
            <span :class="[$style.heading__2, 'text-center']">TOTAL DE<span>{{ userTrail.courses.length }} cursos</span></span>
          </div>
          <div class="px-0 px-md-4 py-2 py-md-0">
            <span :class="[$style.heading__2, 'text-center']">CARGA HORÁRIA<span>{{ userTrail.trail_duration }}</span></span>
          </div>
          <div class="px-0 px-md-4 py-2 py-md-0">
            <span :class="[$style.heading__2, 'text-center']">CONTEÚDO CRIADO POR<span>{{ userTrail.authors.length }} especialistas</span></span>
          </div>
        </div>
      </section>

      <section :class="$style.mb__48">
        <h6 class="mb-0 text-center">TRILHA RUMO A</h6>
        <h5 class="mb-4 text-center">PROFISSIONALIZAÇÃO</h5>

        <TrailRoadmap
          v-if="userTrail.courses"
          :courses="userTrail.courses"
        />
      </section>
    </div>
  </div>
</template>

<script>
import TrailRoadmap from '@/components/trail/TrailRoadmap'
import LoadingContainer from '@/components/layout/LoadingContainer'
import { useUserTrail } from '@/components/trail/trail'
import TrailBodyBackground from '@/components/trail/TrailBodyBackground'

export default {
  name: 'UserTrailPage',

  components: {
    TrailRoadmap,
    LoadingContainer,
    TrailBodyBackground,
  },
  
  setup () { 
    const { userTrail } = useUserTrail()

    return { userTrail }
  }
}
</script>

<style module lang="scss">
@import "~@/components/trail/trail.scss";

.changeButton {
  margin-bottom: 2rem;
  text-decoration: underline;

  &:hover {
    text-decoration: underline !important;
  }
}
</style>